import React from 'react';
import { Provider, defaultTheme } from '@adobe/react-spectrum';
import Index from './components';
import './assets/styles/style.scss';
// import Config from './config/env_variables';

function App() {
  // console.log('config', Config);
  return (
    <Provider theme={defaultTheme} backgroundColor="#f5f5f5" height="100%" width="100%">
      <div className="globalContainer">
        <Index />
      </div>
    </Provider>
  );
}

export default App;
